import { render, staticRenderFns } from "./settingWorkDocsDocumentType.vue?vue&type=template&id=00a8c1b3&"
import script from "./settingWorkDocsDocumentType.vue?vue&type=script&lang=js&"
export * from "./settingWorkDocsDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports